import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {GLOBAL} from './global.service';
import {map} from 'rxjs/operators';
import {Preference, PreferenceSortSave} from '../models/preference';

@Injectable({
  providedIn: 'root'
})
export class PreferenceService {
  url;
  service = 'preferenceService';
  preferences: Preference[];
  cargando = true;

  constructor(private _http: HttpClient) {
    this.url = GLOBAL.url;
    if (!this.preferences) {
        this.getConfig();
    }
  }

  getPreferences(page, keyToFind, value = null) {
    let params: HttpParams = new HttpParams();
    if (keyToFind != undefined) {
      params = params.set('key', keyToFind);
    }
    if (value != undefined) {
      params = params.set('value', value);
    }
    return this._http.get(this.url + this.service + '/listSearch/' + page,
      {responseType: 'text', observe: 'response', headers: new HttpHeaders(), params}).pipe(map(res => {
      return res;
    }));
  }

  removePreference(id) {
    return this._http.delete(this.url + this.service + '/' + id, {observe: 'response', headers: new HttpHeaders()});
  }

  addPreference(preference: Preference) {
    let body = JSON.stringify(preference);
    return this._http
      .post(this.url + this.service, body, {
        observe: 'response',
        headers: new HttpHeaders()
      });
  }

  updatePreference(preference: Preference) {
    let body = JSON.stringify(preference);
    return this._http
      .put(this.url + this.service, body, {
        observe: 'response',
        headers: new HttpHeaders()
      });
  }


  savePreferenceSort(preferenceSortSave: PreferenceSortSave) {
    let body = JSON.stringify(preferenceSortSave);
    return this._http
      .put(this.url + this.service + '/sort', body, {
        observe: 'response',
        headers: new HttpHeaders()
      });
  }

  getCotizacionDolar = () => {
    return new Promise(resolve => {
      this.getPreferences(0, `dolar`)
        .subscribe(
          (data) => {
            let body = JSON.parse(data.body);
            let preferences: Preference[] = body.rows;
            if (preferences.length <= 0 ) {
              throw new Error(`la cotizacion del dolar no esta configurada`);
            }
            resolve(preferences[0].value);
          },
          error => {
            throw new Error(`no se pudo obtener la cotizacion del dolar`);
          });
    });
  }

  updateDolar = (dolar) => {
    let body = JSON.stringify(dolar);
    return this._http.put(this.url + this.service + '/updateDolar', body, { observe: 'response', headers: new HttpHeaders() }
    ).pipe(map(
      res => res
    ));
  }

    getConfig(): Promise<void> {
        return new Promise<void>(resolve => {
            this.getPreferences('0', 'config').subscribe(
                res => {
                    const body = JSON.parse(res.body);
                    this.preferences = body.rows;
                    this.cargando = false;
                    return resolve();
                },
                err => {
                    throw new Error(`no se pudo obtener las preferencias`);
                }
            );
        });
    }

}
